export default [
  {
    path: 'google-maps',
    name: 'Google Maps',
    component: () => import('./../../../views/GoogleMaps')
  },
]
